import Icon from "@/components/icons";
import { type Reason as ReasonProps } from "../types";

export const Reason = ({ icon, title, description }: ReasonProps) => (
  <article className="flex items-center">
    <Icon
      type={icon}
      svgProps={{
        width: 58,
        height: 58,
        role: "img",
        "aria-label": title,
        className: "text-primary-500 shrink-0 mr-2.5",
      }}
    />

    <div>
      <h3 className="text-lg md:text-xl font-bold m-0">{title}</h3>
      <p className="text-base md:text-lg m-0">{description}</p>
    </div>
  </article>
);
